import _typeof from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.pad-start.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCustomerList } from '@/views/cardSystem/customer/api/index';
import { getProjectTicketSelect, getProjectTicketItem, createProjectTicket, getProjectTicketOrderList, getProjectTicketInfo, getProjectTicketLog } from '../api';
export default {
  name: 'ticketForm',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: 'add'
    },
    customerName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      activeTab: '1',
      logList: [],
      logSearchForm: {
        id: this.id,
        pageSize: 20,
        page: 1
      },
      logPages: {
        currentPage: 1,
        totalCount: 0
      },
      companyList: [],
      ticketCategoryTree: [],
      ticketOrderList: [],
      ticketSubmitLoading: false,
      ticketItemOptions: [],
      ticketForm: {
        category_id: null,
        second_category_id: null,
        item_id: null,
        customer_id: null,
        order_no: '',
        title: '',
        description: ''
      },
      ticketFormRules: {
        category_id: [{
          required: true,
          message: '请选择一级事项',
          trigger: 'change'
        }],
        second_category_id: [{
          required: true,
          message: '请选择二级事项',
          trigger: 'change'
        }],
        item_id: [{
          required: true,
          message: '请选择具体事项',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请输入工单标题',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: '请输入事项描述',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    isView: function isView() {
      return this.type === 'view';
    },
    ticketUserInfo: function ticketUserInfo() {
      return this.$store.state.user.userInfo || {};
    },
    ticketSecondCategoryOptions: function ticketSecondCategoryOptions() {
      var _this = this;
      if (!this.ticketForm.category_id) return [];
      var node = this.ticketCategoryTree.find(function (item) {
        return item.id === _this.ticketForm.category_id;
      });
      return node && node.children || [];
    }
  },
  watch: {
    // 抽屉为 destroy-on-close：组件创建时 visible 已是 true，需 immediate 才能在首次挂载时触发
    visible: {
      immediate: true,
      handler: function handler(val) {
        if (val) this.init();
      }
    }
  },
  methods: {
    init: function init() {
      this.resetForm();
      this.activeTab = '1';
      this.logSearchForm.id = this.id;
      if (this.type === 'view' && this.id) {
        this.loadTicketDetail();
        return;
      }
      if (!this.ticketCategoryTree.length) {
        this.getTicketCategoryTree();
      }
      this.getCompanyList();
    },
    loadTicketDetail: function loadTicketDetail() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, detail, itemRes, exists, orderRes;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (_this2.ticketCategoryTree.length) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return _this2.getTicketCategoryTree();
            case 1:
              _context.n = 2;
              return getProjectTicketInfo({
                id: _this2.id
              });
            case 2:
              res = _context.v;
              detail = res.data || {};
              _this2.ticketForm = {
                // 选项树 id 均为字符串，radio 的 === 匹配需归一化类型
                category_id: detail.category_id != null ? String(detail.category_id) : null,
                second_category_id: detail.second_category_id != null ? String(detail.second_category_id) : null,
                item_id: detail.item_id != null ? String(detail.item_id) : null,
                customer_id: detail.customer_id != null ? String(detail.customer_id) : null,
                order_no: _this2.resolveTicketDetailOrderNo(detail),
                title: detail.title || '',
                description: detail.description || ''
              };
              if (!(_this2.ticketForm.second_category_id && _this2.ticketForm.second_category_id !== '0')) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return getProjectTicketItem({
                category_id: _this2.ticketForm.second_category_id
              });
            case 3:
              itemRes = _context.v;
              _this2.ticketItemOptions = _this2.resolveTicketOptions(itemRes);
            case 4:
              if (!_this2.ticketForm.customer_id) {
                _context.n = 7;
                break;
              }
              if (_this2.companyList.length) {
                _context.n = 5;
                break;
              }
              _context.n = 5;
              return _this2.getCompanyList();
            case 5:
              exists = _this2.companyList.some(function (item) {
                return String(item.id) === String(detail.customer_id);
              });
              if (!exists) {
                _this2.companyList = [{
                  id: detail.customer_id,
                  // 深链进入时 customerName 为空，兜底取详情的 customer_info.company_name
                  company_name: _this2.customerName || detail.customer_info && detail.customer_info.company_name || ''
                }].concat(_toConsumableArray(_this2.companyList));
              }
              _context.n = 6;
              return getProjectTicketOrderList({
                customer_id: _this2.ticketForm.customer_id
              });
            case 6:
              orderRes = _context.v;
              _this2.ticketOrderList = _this2.resolveTicketOrderList(orderRes);
              if (_this2.ticketForm.order_no && !_this2.ticketOrderList.includes(_this2.ticketForm.order_no)) {
                _this2.ticketOrderList = [_this2.ticketForm.order_no].concat(_toConsumableArray(_this2.ticketOrderList));
              }
            case 7:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    resolveTicketDetailOrderNo: function resolveTicketDetailOrderNo(detail) {
      if (Array.isArray(detail.order_no) && detail.order_no.length) {
        return String(detail.order_no[0]);
      }
      if (detail.order_no) return String(detail.order_no);
      if (!Array.isArray(detail.order) || !detail.order.length) return '';
      var first = detail.order[0];
      if (!first || _typeof(first) !== 'object') return '';
      return first.order_no != null ? String(first.order_no) : '';
    },
    resetForm: function resetForm() {
      var _this3 = this;
      this.ticketForm = {
        category_id: null,
        second_category_id: null,
        item_id: null,
        customer_id: null,
        order_no: '',
        title: '',
        description: ''
      };
      this.ticketItemOptions = [];
      this.ticketOrderList = [];
      this.$nextTick(function () {
        _this3.$refs.ticketForm && _this3.$refs.ticketForm.clearValidate();
      });
    },
    getCompanyList: function getCompanyList(val) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 1:
              res = _context2.v;
              _this4.companyList = res.data.list;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getTicketCategoryTree: function getTicketCategoryTree() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return getProjectTicketSelect();
            case 1:
              res = _context3.v;
              _this5.ticketCategoryTree = res.data && res.data.tree || [];
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    changeTicketFirstCategory: function changeTicketFirstCategory() {
      this.ticketForm.second_category_id = null;
      // 二级事项只有一个选项时自动选中；没有真实选项（仅剩"其他"）时也自动选中"其他"
      if (this.ticketSecondCategoryOptions.length === 1) {
        this.ticketForm.second_category_id = this.ticketSecondCategoryOptions[0].id;
      } else if (!this.ticketSecondCategoryOptions.length) {
        this.ticketForm.second_category_id = '0';
      }
      this.changeTicketSecondCategory();
    },
    changeTicketCustomer: function changeTicketCustomer(customerId) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this6.ticketForm.order_no = '';
              _this6.ticketOrderList = [];
              if (customerId) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return getProjectTicketOrderList({
                customer_id: customerId
              });
            case 2:
              res = _context4.v;
              _this6.ticketOrderList = _this6.resolveTicketOrderList(res);
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    resolveTicketOrderList: function resolveTicketOrderList(res) {
      var data = res.data;
      var list = [];
      if (Array.isArray(data)) {
        list = data;
      } else if (data && _typeof(data) === 'object') {
        list = Object.keys(data).map(function (key) {
          return data[key];
        });
      }
      return list.map(function (item) {
        return _typeof(item) === 'object' && item ? String(item.id) : String(item);
      }).filter(function (item) {
        return item && item !== 'undefined' && item !== 'null';
      });
    },
    changeTicketSecondCategory: function changeTicketSecondCategory() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this7.ticketForm.item_id = null;
              _this7.ticketItemOptions = [];
              if (_this7.ticketForm.second_category_id) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (!(_this7.ticketForm.second_category_id === '0')) {
                _context5.n = 2;
                break;
              }
              _this7.ticketForm.item_id = '0';
              _this7.generateTicketDefaultTitle();
              return _context5.a(2);
            case 2:
              _context5.n = 3;
              return getProjectTicketItem({
                category_id: _this7.ticketForm.second_category_id
              });
            case 3:
              res = _context5.v;
              _this7.ticketItemOptions = _this7.resolveTicketOptions(res);
              // 具体事项只有一个选项时自动选中；没有真实选项（仅剩"其他"）时自动选中"其他"
              if (_this7.ticketItemOptions.length === 1) {
                _this7.ticketForm.item_id = _this7.ticketItemOptions[0].id;
                _this7.generateTicketDefaultTitle();
              } else if (!_this7.ticketItemOptions.length) {
                _this7.ticketForm.item_id = '0';
                _this7.generateTicketDefaultTitle();
              }
            case 4:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    resolveTicketOptions: function resolveTicketOptions(res) {
      var data = res.data;
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.list)) return data.list;
      if (data && Array.isArray(data.tree)) return data.tree;
      if (data && _typeof(data) === 'object') {
        return Object.keys(data).map(function (key) {
          return data[key];
        }).filter(function (item) {
          return item && item.id && item.name;
        });
      }
      return [];
    },
    generateTicketDefaultTitle: function generateTicketDefaultTitle() {
      var _this8 = this;
      var itemName = this.ticketForm.item_id === '0' ? '其他' : (this.ticketItemOptions.find(function (item) {
        return item.id === _this8.ticketForm.item_id;
      }) || {}).name;
      if (!itemName) return;
      var now = new Date();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      var title = "\u3010\u54A8\u8BE2\u5DE5\u5355\u3011".concat(this.ticketUserInfo.nick_name || '', "\u54A8\u8BE2").concat(itemName, "\u4E8B\u9879-").concat(month).concat(day);
      this.ticketForm.title = title.length > 50 ? title.slice(0, 50) : title;
    },
    submitTicketForm: function submitTicketForm() {
      var _this9 = this;
      this.$refs.ticketForm.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(valid) {
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.p = _context6.n) {
              case 0:
                if (valid) {
                  _context6.n = 1;
                  break;
                }
                return _context6.a(2);
              case 1:
                _this9.ticketSubmitLoading = true;
                _context6.p = 2;
                _context6.n = 3;
                return createProjectTicket({
                  category_id: _this9.ticketForm.category_id,
                  second_category_id: _this9.ticketForm.second_category_id,
                  item_id: _this9.ticketForm.item_id,
                  customer_id: _this9.ticketForm.customer_id || '',
                  order_no: _this9.ticketForm.order_no ? [_this9.ticketForm.order_no] : [],
                  title: _this9.ticketForm.title,
                  description: _this9.ticketForm.description
                });
              case 3:
                _this9.$message.success('提交成功');
                _this9.$emit('success');
              case 4:
                _context6.p = 4;
                _this9.ticketSubmitLoading = false;
                return _context6.f(4);
              case 5:
                return _context6.a(2);
            }
          }, _callee6, null, [[2,, 4, 5]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleCancel: function handleCancel() {
      this.$emit('update:visible', false);
    },
    getLog: function getLog() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return getProjectTicketLog(_this0.logSearchForm);
            case 1:
              res = _context7.v;
              _this0.logList = res.data;
              _this0.logPages = res.pages;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === '2') {
        this.handlePageChange(1);
      }
    },
    handlePageChange: function handlePageChange(page) {
      this.logSearchForm.page = page;
      this.getLog();
    },
    sizeChange: function sizeChange(size) {
      this.logSearchForm.pageSize = size;
      this.logSearchForm.page = 1;
      this.getLog();
    }
  }
};